import { sendAnalytics } from '@audio-network/analytics'
import { NavBar, NavBarItem, Text } from '@audio-network/componentlibrary'
import { Search } from '@audio-network/componentlibrary/icons'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import React, { useEffect, useState } from 'react'

import { usePersistSearchScrollPosition } from '@/pages/track/searchkeyword/index.hooks'
import useAiSearchStore from '@/stores/aiSearchStore'

import styles from './DesktopNavBar.module.css'

const DesktopNavBar = (): JSX.Element => {
	const { t } = useTranslation(['navigation'])

	const { clearAiSearch } = useAiSearchStore()

	const router = useRouter()
	const [currentPath, setCurrentPath] = useState(router.pathname)
	const { clearSearchScrollPosition } = usePersistSearchScrollPosition()

	useEffect(() => {
		const handleRouteChange = (url: string): void => {
			setCurrentPath(url)
		}

		router.events.on('routeChangeStart', handleRouteChange)

		return () => {
			router.events.off('routeChangeStart', handleRouteChange)
		}
	}, [router])

	const handleClick = (noun: string): void => {
		if (noun === 'Search') {
			/**
			 * Clean up any scroll positioning when navigating to search
			 *
			 * See Results.utils.ts for set up.
			 */
			clearSearchScrollPosition()
			/**
			 * Clean up AI searching
			 */
			clearAiSearch()
			document.getElementById('main-content')?.scrollTo(0, 0)
		}

		sendAnalytics({
			noun,
			pastTenseVerb: 'Clicked',
			eventParameters: {
				Location: 'Music App Navigation',
			},
		})
	}
	return (
		<NavBar className={styles.desktopNavBar} id="desktop-nav-bar">
			<NavBarItem
				content={t('music')}
				href="/track/searchkeyword"
				startIcon={<Search />}
				onClick={() => handleClick('Search')}
				aria-current={
					currentPath === '/track/searchkeyword' ? 'page' : undefined
				}
				id="search-link"
			/>
			<NavBarItem
				content={t('playlists')}
				href="/playlist-hub"
				onClick={() => handleClick('Playlists')}
				aria-current={currentPath === '/playlist-hub' ? 'page' : undefined}
			/>
			<NavBarItem
				content={t('albums')}
				href="/albums"
				onClick={() => handleClick('Albums')}
				aria-current={currentPath === '/albums' ? 'page' : undefined}
				data-navitem="albums"
			/>
			<NavBarItem
				content={t('collections')}
				href="/collections"
				onClick={() => handleClick('Collections')}
				aria-current={currentPath === '/collections' ? 'page' : undefined}
			/>
			<NavBarItem
				aria-label={t('sound-effects')}
				href="/sound-effects"
				content={
					<>
						<Text aria-hidden className={styles.sfx}>
							{t('sfx')}
						</Text>
						<Text aria-hidden className={styles.soundEffects}>
							{t('sound-effects')}
						</Text>
					</>
				}
				onClick={() => handleClick('Sound Effects')}
				aria-current={currentPath === '/sound-effects' ? 'page' : undefined}
				id="sound-effects-link"
			/>
		</NavBar>
	)
}

export default DesktopNavBar
